<div class="modal-header bg-head py-2 d-flex justify-content-between align-items-center">
  <h6 class="modal-title mb-0">Admin : FlashCard Management : List</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 border-bottom headersize py-2">
    <span class="px-4 my-2 path-class"> {{path}}</span>
  </div>
</div>

<div class="modal-header">
  <div class="d-flex flex-row flex-nowrap align-items-center gap-3 w-100 overflow-auto px-1">

    <!-- Sort Field -->
    <div class="input-group input-group-sm flex-grow-1" style="min-width: 218px; max-width: 12%;">
      <label class="input-group-text" for="sortField">Sort by:</label>
      <select class="form-select" id="sortField" [(ngModel)]="sortField" aria-label="Sort field">
        <option value="Creation_Date">Date Created</option>
        <option value="Created_By">Created By</option>
        <option value="Display_Order">Display Order</option>
        <option value="Updation_Date">Last Updated</option>
        <option value="Updated_By">Updated By</option>
        <option value="Flashcard_Status_Type_Name">Status</option>
        <option value="Language_Type_Name">Language</option>
      </select>
    </div>

    <!-- Sort Direction -->
    <div class="input-group input-group-sm flex-grow-1" style="min-width: 130px; max-width: 7%;">
      <select class="form-select" [(ngModel)]="sortDirection" aria-label="Sort direction">
        <option value="asc">Ascending</option>
        <option value="desc">Descending</option>
      </select>
    </div>

    <!-- Refresh Icon -->
    <div class="d-flex align-items-center" style="min-width: 40px;">
      <i class="fa fa-refresh fs-4 pointer-cursor" title="Refresh List" (click)="refreshList()" aria-hidden="true"></i>
    </div>

  </div>
</div>



<div class="modal-body m-body pt-0 px-0" >
  <!-- Apply cdkDropListAutoScroll to the parent container -->
  <div
  style="height: 80vh; overflow-y: auto;"
  class="example-container-list"
  >
    <div
      *ngFor="let item of filteredFlashcards; let i = index"
      class="w-49"
    >

      <div class="example-box-list">
      <div class="row h-100 w-100 position-relative ">
        <span    class="text-white" style="top:-32px; color:white; z-index:99999" class="position-absolute text-end" >
          <i class="fa fa-pencil-square-o pointer-cursor"  aria-hidden="true"(click)="triggerParentFunction(item)"></i>
          <span *ngIf="item.Display_Order" class="ms-2">{{item.Display_Order}}</span>
        </span>
        <span *ngIf="item.Flashcard_Status_Type_Name"   class="text-white" style="top:-32px; color:white;" class="position-absolute " >{{item.Flashcard_Status_Type_Name}}
        </span>

    <h3 class="text-white position-absolute text-center"
        style="top:-32px"
    >{{item.FlashCard_ID}}</h3>

        <div class="col-md-6 px-0 h-100">
          <div class="w-100 h-100 rounded border-end text-wrap bg-white overflow-auto p-4" style="zoom: 55%; position:relative; top:10px" [innerHTML]="this.SanitizeHTML(item.Front_Side_Text ??'')">
          </div>
          <div class="row mt-2-5">
            <div class="col-12  text-white fs-7 d-flex justify-content-between">
              <span>Created By : {{item.Created_By}} ({{ item.Creation_Date | date: 'short' }})</span>
            </div>

          </div>
        </div>
        <div class="col-md-6 px-0 h-100">
          <div class="w-100 h-100 rounded border-end text-wrap bg-white overflow-auto p-4" style="zoom: 55%; position:relative; top:10px" [innerHTML]="this.SanitizeHTML(item.Back_Side_Text??'')">
          </div>

            <div class="row mt-2-5">
              <div class="col-12 text-white fs-7 ps-4  d-flex justify-content-between">
                <span>Updated By: {{item.Updated_By}} ({{item.Updation_Date | date :'short'}})</span>
              </div>
            </div>
        </div>
      </div>
        <!-- <small>{{ item.FlashCard_ID }}</small> -->
      </div>
    </div>
    <div *ngIf="filteredFlashcards.length === 0" class="alert text-center w-100">
      No flashcards found matching your criteria
    </div>
  </div>

</div>
